// BFS pathfinding algorithm for snake autopilot

export const findPath = (snake, food, gridSize) => {
  const head = snake[0];
  const target = food;
  
  // BFS to find shortest path
  const queue = [{ pos: head, path: [] }];
  const visited = new Set();
  visited.add(`${head.x},${head.y}`);
  
  // Create snake body set for collision detection
  const snakeSet = new Set();
  snake.forEach((segment, index) => {
    // Don't consider tail as obstacle (it will move)
    if (index < snake.length - 1) {
      snakeSet.add(`${segment.x},${segment.y}`);
    }
  });
  
  const directions = [
    { x: 0, y: -1, dir: 'up' },
    { x: 0, y: 1, dir: 'down' },
    { x: -1, y: 0, dir: 'left' },
    { x: 1, y: 0, dir: 'right' }
  ];
  
  while (queue.length > 0) {
    const { pos, path } = queue.shift();
    
    // Found the food
    if (pos.x === target.x && pos.y === target.y) {
      return path.length > 0 ? path[0] : null;
    }
    
    // Try all directions
    for (const dir of directions) {
      const newX = (pos.x + dir.x + gridSize) % gridSize;
      const newY = (pos.y + dir.y + gridSize) % gridSize;
      const key = `${newX},${newY}`;
      
      // Check if valid move
      if (!visited.has(key) && !snakeSet.has(key)) {
        visited.add(key);
        queue.push({
          pos: { x: newX, y: newY },
          path: [...path, { x: dir.x, y: dir.y }]
        });
      }
    }
  }
  
  // No path found - just move in any safe direction
  for (const dir of directions) {
    const newX = (head.x + dir.x + gridSize) % gridSize;
    const newY = (head.y + dir.y + gridSize) % gridSize;
    const key = `${newX},${newY}`;
    
    if (!snakeSet.has(key)) {
      return { x: dir.x, y: dir.y };
    }
  }
  
  // Last resort - move in any direction
  return { x: 1, y: 0 };
};
